var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m5 2c-2.2022 0-4 1.7978-4 4v8c0 2.2022 1.7978 4 4 4h9.8828c2.2022 0 4-1.7978 4-4v-8c0-2.2022-1.7978-4-4-4zm0 1.5996h9.8828c1.3434 0 2.4004 1.057 2.4004 2.4004v8c0 1.3434-1.057 2.4004-2.4004 2.4004h-9.8828c-1.3434 0-2.4004-1.057-2.4004-2.4004v-8c0-1.3434 1.057-2.4004 2.4004-2.4004z",
    color: "#000000",
    fill: "#71839b",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#71839b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.0882 10.47a1.3824 1.3824 0 0 1-1.3823 1.3824 1.3824 1.3824 0 0 1-1.3824-1.3824 1.3824 1.3824 0 0 1 1.3824-1.3824 1.3824 1.3824 0 0 1 1.3823 1.3824z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.7051 8.5879c-1.0337 0-1.8809 0.84914-1.8809 1.8828 0 1.0337 0.84719 1.8828 1.8809 1.8828 1.0337 0 1.8828-0.84914 1.8828-1.8828 0-1.0337-0.84914-1.8828-1.8828-1.8828zm0 1c0.49323 0 0.88281 0.38958 0.88281 0.88281s-0.38958 0.88281-0.88281 0.88281-0.88086-0.38958-0.88086-0.88281 0.38763-0.88281 0.88086-0.88281z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4706 9.9998h5.6471c0.26071 0 0.47059 0.20988 0.47059 0.47059 0 0.2607-0.20988 0.47059-0.47059 0.47059h-5.6471c-0.26071 0-0.47059-0.20988-0.47059-0.47059s0.20988-0.47059 0.47059-0.47059z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4707 9.5293c-0.51327 0-0.94141 0.42814-0.94141 0.94141s0.42814 0.94141 0.94141 0.94141h5.6465c0.51327 0 0.94141-0.42814 0.94141-0.94141s-0.42814-0.94141-0.94141-0.94141z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonsIcon);
export default __webpack_public_path__ + "static/media/buttons-icon.d768e81c396d57fda703ba570964b1f7.svg";
export { ForwardRef as ReactComponent };